"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var SvgNoRequest = function SvgNoRequest(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 225,
    height: 187,
    viewBox: "0 0 225 187",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 5.52A3.52 3.52 0 015.52 2h177.96A3.52 3.52 0 01187 5.52V163H2V5.52z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 3
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#EFEFFA",
    d: "M8 31h174v125H8z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M8 74h174v39H8zM8 12.52A3.52 3.52 0 0111.52 9h166.96a3.52 3.52 0 013.52 3.52V31H8V12.52z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 12.52A3.52 3.52 0 0111.52 9h166.96a3.52 3.52 0 013.52 3.52V31H8V12.52z",
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 43,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 43,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 55,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 55,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 144,
    y: 49,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 144,
    y: 49,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 48,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 48,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 84,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 84,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 96,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 96,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 144,
    y: 90,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 144,
    y: 90,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 88,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 88,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 62.5,
    cy: 93.5,
    r: 15.5,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 62.5,
    cy: 93.5,
    r: 15.5,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 62.5,
    cy: 51.5,
    r: 15.5,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 126,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 126,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 62.5,
    cy: 134.5,
    r: 15.5,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 137,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 137,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 144,
    y: 131,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 144,
    y: 131,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 130,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 130,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 143,
    y: 17,
    width: 28,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 49,
    y: 17,
    width: 43,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 15,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192 99c-18.225 0-33 14.773-33 33 0 1.518.103 3.029.309 4.523l-21.101 21.102a4.124 4.124 0 00-1.208 2.916v22.334a4.125 4.125 0 004.125 4.125h24.75a4.125 4.125 0 004.125-4.125v-4.125h4.125a4.125 4.125 0 004.125-4.125v-3.437l6.883-6.904A33.06 33.06 0 00192 165c18.225 0 33-14.773 33-33 0-18.225-14.773-33-33-33z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.003 131.802c0 14.143-11.524 25.609-25.739 25.609-3.391 0-5.695.254-8.659-.932l-6.177 6.435h-5.72v8.537h-8.58v8.536h-19.012v-19.012l23.117-23.568c-.477-1.471-.709-3.459-.709-5.605 0-14.144 11.524-25.61 25.74-25.61 14.215 0 25.739 11.466 25.739 25.61z",
    fill: "#fff",
    fillOpacity: 0.96
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M150.273 164.941l17.849-18.888M156.518 169.044l11.604-12.259",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.732 124.219a8.048 8.048 0 008.049 8.049 8.048 8.048 0 008.048-8.049 8.048 8.048 0 00-8.048-8.048 8.048 8.048 0 00-8.049 8.048z",
    fill: "currentColor"
  }));
};
var _default = exports.default = SvgNoRequest;